export default __webpack_public_path__ + "static/media/czech-republic.bb724f16.png";